<template>
  <v-card flat color="transparent" class="elevation-12">
    <div style="margin: auto 3%">
      <!-- search by word -->
      <div
        style="
          min-width: 700px;
          display: flex;
          flex-flow: wrap;
          justify-content: start;
          align-items: center;
          height: 60px;
        "
      >
        <!-- select categories -->
        <div style="font-size: 23px; font-weight: bold; width: 120px">
          Category
        </div>
        <v-select
          v-model="column"
          label="Category"
          :items="searchSelects"
          item-text="name"
          item-value="value"
          style="max-width: 160px; min-width: 100px"
          single-line
          color="#05523E"
        />
        <!-- input word -->
        <v-text-field
          v-model="search"
          clearable
          style="
            margin: auto 10px;
            max-width: 150px;
            min-width: 100px;
            height: 62px;
          "
          placeholder="Search"
          v-on:keyup.enter="searchByWord"
        />
        <v-btn
          class="white--text elevation-5 rounded-lg"
          color="#05523E"
          style="max-width: 140px; min-width: 120px; height: 35px"
          @click="searchByWord"
          >Search</v-btn
        >
        <!-- <v-btn
          @click="downloadExel"
          class="rounded-lg"
          style="color: #05523e; height: 40px; position: absolute; right: 3%"
        >
          <v-icon color="#05523E">mdi-microsoft-excel</v-icon>
          &nbsp;Detailed Department Sales
        </v-btn> -->
      </div>
      <!-- search by date -->
      <div
        style="
          display: flex;
          justify-content: start;
          align-items: center;
          height: 40px;
          margin-bottom: 20px;
        "
      >
        <div style="font-size: 23px; font-weight: bold; width: 120px">Date</div>
        <div>
          <v-menu
            v-model="startDateMenu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                style="width: 125px"
                append-icon="mdi-calendar"
                v-model="startDate"
                readonly
                color="#05523E"
                v-bind="attrs"
                v-on="on"
                v-on:change="dateValidation"
              />
            </template>
            <v-date-picker
              color="#05523E"
              v-model="startDate"
              v-on:change="dateValidation"
              @input="startDateMenu = false"
            />
          </v-menu>
        </div>
        <div style="margin-left: 2%">
          <v-menu
            v-model="endDateMenu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                style="width: 125px"
                append-icon="mdi-calendar"
                v-model="endDate"
                readonly
                color="#05523E"
                v-bind="attrs"
                v-on="on"
              />
            </template>
            <v-date-picker
              color="#05523E"
              v-model="endDate"
              v-on:change="dateValidation"
              @input="endDateMenu = false"
            />
          </v-menu>
        </div>
        <!-- search by status -->
        <div
          style="
            font-size: 23px;
            font-weight: bold;
            margin-left: 60px;
            margin-right: 25px;
          "
        >
          Status
        </div>
        <v-select
          label="All"
          :items="statusSelects"
          v-model="status"
          item-text="name"
          item-value="value"
          v-on:change="dateValidation"
          style="max-width: 160px; min-width: 100px"
          single-line
          color="#05523E"
        />
        <v-btn
          @click="insertModal = true"
          class="rounded-lg"
          style="color: #05523e; height: 40px; position: absolute; right: 3%"
          >Add Invoice</v-btn
        >
      </div>
      <div v-show="isShow" style="padding-bottom: 20px">
        <v-data-table
          :headers="headers"
          :items="$store.state.invoice.invoiceList"
          :page.sync="page_No"
          :items-per-page="10"
          hide-default-footer
          class="elevation-3"
          :loading="loading"
        >
          <!-- <template v-slot:header="{ props: { headers } }">
                    <thead>
                        <tr>
                            <th v-for="h in headers" v-bind:key="h.text">
                                <span style="color: black; font-weight: bold; font-size: 17px;">{{h.text}}</span>
                            </th>
                        </tr>
                    </thead>
                    </template> -->
          <template v-slot:item="{ item }">
            <tr @click="clickRow(item)">
              <td>{{ item.orderTime }}</td>
              <td>{{ item.invoiceNumber }}</td>
              <td>{{ item.status }}</td>
              <td>{{ item.company }}</td>
              <td>{{ item.custNumber }}</td>
            </tr>
          </template>
        </v-data-table>
        <div class="text-center pt-2">
          <v-pagination
            style="padding-top: 8px"
            color="#05523E"
            v-model="page_No"
            :length="$store.state.invoice.inventoryPages"
            :total-visible="10"
            @input="movePage"
          />
          <div v-if="$store.state.common.editInvoiceOneModalView">
            <v-dialog
              class="rounded-lg"
              v-model="$store.state.common.editInvoiceOneModalView"
              width="1900"
            >
              <EditInvoiceOneModal
                :loading="modalLoading"
                v-bind:propStatus="propStatus"
                @getInvoiceList="getInvoiceList"
              />
            </v-dialog>
          </div>
          <div v-if="insertModal">
            <v-dialog
              class="rounded-lg"
              v-model="insertModal"
              width="1900"
              @click:outside="closeAddModal"
            >
              <AddInvoiceModal @closeAddModal="closeAddModal" />
            </v-dialog>
          </div>
        </div>
      </div>
      <div
        v-show="!$store.state.common.isLoading && !isShow"
        style="font-size: 20px"
      >
        <div
          style="
            margin: 0% 0% 0% 420px;
            font-size: 40px;
            color: #05523e;
            font-weight: bold;
          "
        >
          No data was retrieved.
        </div>
        <img
          style="width: 700px; height: 600px; margin: 0% 0% 0% 250px"
          src="@/assets/noData.jpg"
        />
      </div>
    </div>
  </v-card>
</template>

<script>
import EditInvoiceOneModal from "@/components/modal/EditInvoiceOneModal.vue";
import AddInvoiceModal from "@/components/modal/AddInvoiceModal.vue";
import { runGqlQuery } from "@/graphql/gqlUtil.js";
import {
  GETINVOICE,
  GETINVOICELENGTH,
  CHECKITEMANDCRV,
  GETINVENTORYFORTAG,
} from "@/graphql/InvoiceQueries.js";
import common from "@/util/common.js";
import Demical, { Decimal } from "decimal.js";

export default {
  components: {
    EditInvoiceOneModal,
    AddInvoiceModal,
  },
  data() {
    return {
      insertModal: false,
      modalLoading: false,
      searchSelects: [
        { name: "Category", value: "" },
        { name: "Invoice Number", value: "Invoice_Number" },
        { name: "Company Name", value: "Company" },
        { name: "Cust Number", value: "CustNum" },
      ],
      statusSelects: [
        { name: "All", value: "" },
        { name: "Onhold", value: "O" },
        { name: "Vendor", value: "V" },
        { name: "Customer", value: "C" },
      ],
      startDate: "",
      startDateMenu: false,
      endDate: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      endDateMenu: false,
      column: "",
      search: "",
      status: "",
      page_No: 1,
      custNum: "",
      items: [{ tabName: "Invoice" }, { tabName: "Shortage" }],
      headers: [
        {
          text: "Order Time",
          align: "start",
          sortable: true,
          value: "orderTime",
        },
        { text: "Invoice Number", value: "invoiceNumber" },
        { text: "Status", value: "status" },
        { text: "Company Name", value: "company" },
        { text: "Cust Number", value: "custNumber" },
      ],
      isShow: true,
      propStatus: "",
      loading: false,
    };
  },
  props: {
    source: String,
  },
  async created() {
    this.loading = true;
    this.startDate = await common.calculateDate(this.endDate, -30);
    await this.getInvoiceListLength(true);
    await this.getInvoiceList(true);
    this.loading = false;
  },
  methods: {
    async closeAddModal() {
      this.insertModal = false;
      this.loading = true;
      this.startDate = await common.calculateDate(this.endDate, -30);
      await this.getInvoiceListLength(true);
      await this.getInvoiceList(true);
      this.loading = false;
    },
    async getInvoiceListLength(IsLike) {
      try {
        const req = {
          column: this.column,
          search: this.search,
          status: this.status,
          startDate: this.startDate,
          endDate: this.endDate,
        };
        if (IsLike) req.IsLike = IsLike;

        const invoicePage = await runGqlQuery(GETINVOICELENGTH, req);

        this.$store.state.invoice.inventoryPages = Math.ceil(
          invoicePage.getInvoicesLength.Length / 10
        );
      } catch (err) {
        console.error(err);
      }
    },
    async getInvoiceList(IsLike) {
      try {
        const req = {
          column: this.column,
          search: this.search,
          status: this.status,
          startDate: this.startDate,
          endDate: this.endDate,
          page_No: this.page_No - 1,
          page_Size: 10,
        };

        if (IsLike) req.IsLike = IsLike;

        const invoiceResult = await runGqlQuery(GETINVOICE, req);
        console.log(invoiceResult.getInvoices);

        if (
          invoiceResult !== undefined &&
          invoiceResult.getInvoices.length !== 0
        ) {
          this.$store.commit("invoice/setInvoiceList", {
            invoices: invoiceResult.getInvoices,
          });
          this.isShow = true;
        } else {
          this.isShow = false;
        }
      } catch (err) {
        console.error(err);
      }
    },
    async searchByWord() {
      this.loading = true;
      if (this.column === "" && this.search === null) {
        await this.searchInvoice();
      } else if (this.column === "" && this.search !== "") {
        this.loading = false;
        return this.$store.commit("common/snackErrOn", {
          text: "Please select a category!",
        });
      }
      await this.searchInvoice();
      this.loading = false;
    },
    async searchInvoice() {
      this.loading = true;

      await this.getInvoiceListLength(true);
      this.page_No = 1;
      await this.getInvoiceList(true);
      this.loading = false;
    },
    async dateValidation() {
      this.loading = true;
      // 시작 날짜와 끝 날짜 같으면 시작 날짜 하루 빼기
      if (this.startDate == this.endDate) {
        this.startDate = common.calculateDate(this.startDate, -1);
      }
      // 시작 날짜가 끝 날짜 보다 늦으면
      if (new Date(this.endDate) - new Date(this.startDate) < 0) {
        this.startDate = await common.calculateDate(this.endDate, -1);
        this.$store.commit("common/snackErrOn", {
          text: "The date was entered incorrectly!",
        });
      }

      await this.searchInvoice();
      this.loading = false;
    },
    async clickRow(item) {
      try {
        this.modalLoading = true;
        this.$store.commit("common/changeEditInvoiceOneModalView");

        this.propStatus = item.status;

        const invoiceResult = await runGqlQuery(GETINVOICE, {
          column: "Invoice_Number",
          search: item.invoiceNumber + "",
        });

        if (invoiceResult !== undefined) {
          const template = JSON.parse(
            JSON.stringify(invoiceResult.getInvoices[0].Invoice_Number)
          );
          let add = [];
          for (let i = 0; i < template.length; i++) {
            const checkCrv = await runGqlQuery(CHECKITEMANDCRV, {
              ItemNum: `${template[i].ItemNum}`,
            });
            if (checkCrv.checkItemAndCRV.ItemType === "NONE") {
              add.push({
                ...template[i],
                QuantityApply: template[i].Quantity,
                PriceApply: template[i].PricePer,
                Profit: this.roundToTwo(
                  template[i].PricePer * 1 * template[i].Quantity -
                    template[i].CostPer * 1 * template[i].Quantity
                ),
                ProfitPer:
                  template[i].Quantity != 0
                    ? this.getProfitPer2(
                        template[i].PricePer,
                        template[i].CostPer
                      )
                    : 0,
              });
            } else if (checkCrv.checkItemAndCRV.ItemType === "ITEM") {
              add.push({
                ...template[i],
                QuantityApply: template[i].Quantity,
                PriceApply: template[i].PricePer,
                MappingLineNum: template[i].LineNum + 1,
                Type: "Item",
                Profit: this.roundToTwo(
                  template[i].PricePer * 1 * template[i].Quantity -
                    template[i].CostPer * 1 * template[i].Quantity
                ),
                ProfitPer:
                  item.Quantity != 0
                    ? this.getProfitPer2(
                        template[i].PricePer,
                        template[i].CostPer
                      )
                    : 0,
              });
              add.push({
                ...template[i + 1],
                QuantityApply: template[i].Quantity,
                PriceApply: template[i + 1].PricePer,
                MappedLineNum: template[i].LineNum,
                Type: "CRV",
                Profit: this.roundToTwo(
                  template[i + 1].PricePer * 1 * template[i + 1].Quantity -
                    template[i + 1].CostPer * 1 * template[i + 1].Quantity
                ),
                ProfitPer:
                  template[i + 1].Quantity != 0
                    ? this.getProfitPer2(
                        template[i + 1].PricePer,
                        template[i + 1].CostPer
                      )
                    : 0,
              });
              i++
            }
          }

          // const add = invoiceResult.getInvoices[0].Invoice_Number.map(
          //   (item) => {
          //     return {
          //       ...item,
          //       QuantityApply: item.Quantity,
          //       PriceApply: item.PricePer,
          //       Profit: this.roundToTwo(
          //         item.PricePer * 1 * item.Quantity -
          //           item.CostPer * 1 * item.Quantity
          //       ),
          //       ProfitPer:
          //         item.Quantity != 0
          //           ? this.getProfitPer2(item.PricePer, item.CostPer)
          //           : 0,
          //     };
          //   }
          // );
          console.log(add);
          invoiceResult.getInvoices[0].Invoice_Number = add;
          await this.$store.commit(
            "invoice/setInvoiceOne",
            invoiceResult.getInvoices[0]
          );
          await this.$store.commit(
            "invoice/setInvoiceOneOrigin",
            JSON.parse(JSON.stringify(invoiceResult.getInvoices[0]))
          );
        }
        this.modalLoading = false;
      } catch (err) {
        console.error(err);
      }
    },

    roundToTwo(num) {
      return +(Math.round(num + "e+2") + "e-2");
    },
    getProfitPer2(price, cost) {
      return this.round(
        ((Demical((price * 1 - cost * 1) / cost) * 1 * 100) / 1).toFixed(3)
      );
      //this.getProfitPer(
      //);
    },
    round(num) {
      var m = Number((Math.abs(num) * 100).toPrecision(15));
      return (Math.round(m) / 100) * Math.sign(num);
    },
    async movePage(page) {
      this.loading = true;
      try {
        this.Page_No = page;
        await this.getInvoiceList(true);
      } catch (err) {
        console.error(err);
      }
      this.loading = false;
    },
    typeMoney: (money) => {
      if (typeof money !== "number" && money === "0.0") {
        return money;
      } else if (0 <= money && money < 1000) {
        money += "";
        const sep = money.split(".");

        if (sep[1] !== undefined && sep[1].length > 2) {
          sep[1] = sep[1].substring(0, 3);
          sep[1] /= 10;
          sep[1] = Math.round(sep[1]);
          return sep[0] + "." + sep[1];
        }

        return money;
      } else if (money < 0 || 1000 <= money) {
        let ifMinus = false;

        if (money < 0) {
          ifMinus = true;
          money = Math.abs(money);
        }

        money += "";
        const sep = money.split(".");
        let result = "";

        for (let i = 1; i <= sep[0].length; i++) {
          result = sep[0][sep[0].length - i] + result;
          if (i % 3 === 0 && i !== sep[0].length) {
            result = "," + result;
          }
        }

        if (sep[1] !== undefined) {
          if (sep[1].length > 2) {
            sep[1] = sep[1].substring(0, 3);
            sep[1] /= 10;
            sep[1] = Math.round(sep[1]);
          }
          result += "." + sep[1];
        }
        if (ifMinus) result = "-" + result;
        return result;
      }
    },
    async downloadExel() {
      try {
        const day = new Date();
        const today =
          (await day.getFullYear()) +
          "-" +
          String(day.getMonth() + 1).padStart(2, "0") +
          "-" +
          String(day.getDate()).padStart(2, "0");

        let element = document.createElement("a");
        element.setAttribute("href", process.env.VUE_APP_HTTP + today);
        element.setAttribute("download", today);
        element.click();
      } catch (err) {
        console.error(err);
      }
    },
  },
};
</script>
